import { useEffect, useState } from "react";
import styles from "../styles/Header.module.css";

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 70);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`${styles.header} ${
        scrolled ? styles.scrolled : ""
      }`}
    >
      <div className={styles.container}>
        <div className={styles.logo}>
          Kitchen<span>Bar</span>
        </div>

        <nav className={styles.nav}>
          <a href="#home">Home</a>
          <a href="#menu">Menu</a>
          <a href="#gallery">Gallery</a>
          <a href="#events">Events</a>
          <a href="#contact">Contact</a>
        </nav>

        <a href="#reservation" className={styles.button}>
          Reserve Table
        </a>
      </div>
    </header>
  );
}

export default Header;